export default __webpack_public_path__ + "static/media/bagIllustrator.859ae1ae.svg";